import { render, staticRenderFns } from "./SieLanguageButton.vue?vue&type=template&id=590a9c58"
import script from "./SieLanguageButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SieLanguageButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports